module.exports = __webpack_public_path__ + "img/p.b28245d0.png";